import React, { useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import { SearchBar } from '../../../../components/SearchBar';
import Tree from './components/Tree';
import SmallListServices from '../../../../components/SmallListServices';
import { PlaceStoreContext } from '../../../../reducers/Place/PlaceContext';
import DigitalMenuPreview from '../../../../components/DigitalMenuPreview';

const getServicesCache = (searching, index) => {
  const nameServices = [];

  const containsName = index.namesServices.filter((serviceName) =>
    serviceName.includes(searching.trim().toLowerCase()),
  );

  for (const name of containsName) {
    nameServices.push(index.name__service[name]);
  }

  return nameServices;
};

const TabServices = () => {
  const [placeState] = useContext(PlaceStoreContext);
  const [searching, setSearching] = useState('');
  const [searchedServices, setSearchedServices] = useState([]);
  const [showDigitalMenu, setShowDigitalMenu] = useState(false);
  const [random, setRandom] = useState(0);

  const {
    services: { indexServices },
  } = placeState;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setRandom(random + 1);
  }, [placeState]);

  useEffect(() => {
    if (searching.length > 2) {
      const services = getServicesCache(searching, indexServices);
      services.length > 0 && setSearchedServices(services);
    } else {
      searchedServices.length > 0 && setSearchedServices([]);
    }
  }, [searching, placeState]);

  const toggleShowDigitalMenu = () => {
    setShowDigitalMenu(!showDigitalMenu);
  };

  return (
    <div style={{ margin: '40px 16px 0 16px' }}>
      <Grid container justify="center">
        <Grid item xs={12}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <SearchBar
              searching={searching}
              setSearching={setSearching}
              style={{ height: '36px' }}
              placeholder="Search in services ..."
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={8} md={6} style={{ marginLeft: '20px' }}>
          <SmallListServices services={searchedServices} visible={searching.length > 2} />
        </Grid>
      </Grid>

      {!(searching.length > 2) && (
        <Grid container justify="center" style={{ justifyContent: 'center' }}>
          <Grid item xs={12} sm={9} md={6}>
            <Tree type="services" />
          </Grid>
        </Grid>
      )}
      <DigitalMenuPreview
        showDigitalMenu={showDigitalMenu}
        toggleShowDigitalMenu={toggleShowDigitalMenu}
        random={random}
      />
    </div>
  );
};

export default TabServices;
